// extracted by mini-css-extract-plugin
export default {"actionField":"DataTable_actionField__D4XQd","actionIcon":"DataTable_actionIcon__iBNY-"};